import { render, staticRenderFns } from "./BatimentGlobalData.vue?vue&type=template&id=1a7a3e65&scoped=true&"
import script from "./BatimentGlobalData.vue?vue&type=script&lang=js&"
export * from "./BatimentGlobalData.vue?vue&type=script&lang=js&"
import style0 from "./BatimentGlobalData.vue?vue&type=style&index=0&id=1a7a3e65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7a3e65",
  null
  
)

export default component.exports